import { ActionReducerMapBuilder, PayloadAction, createReducer } from '@reduxjs/toolkit';

import { setConnectionStatus, setDataReloadResource, storeSocketId } from '../actions/sockets';
import { DefaultSocketsState, SocketsState } from '../state/stateItems';
import { TResourceTypeChange } from '@/data/types';

const handleSetConnectionStatus = (state: SocketsState, action: PayloadAction<boolean>) => {
  const status = action?.payload;

  state.isConnected = status;
};

const handleStoreSocketId = (state: SocketsState, action: PayloadAction<string>) => {
  state.socketId = action.payload;
};

const handleSetResourceTypes = (state: SocketsState, action: PayloadAction<TResourceTypeChange[] | null>) => {
  state.resourceType = action.payload;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<SocketsState>) => {
  builder
    .addCase(setConnectionStatus.type, handleSetConnectionStatus)
    .addCase(storeSocketId.type, handleStoreSocketId)
    .addCase(setDataReloadResource.type, handleSetResourceTypes);
};

export default createReducer(DefaultSocketsState, reducerBuilder);
